import { Button, Divider, Skeleton } from '@heroui/react';
import { ArrowRight2 } from 'iconsax-react';

export type SubcategoryListItemsProps = {
  title?: string;
  onPress?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  className?: string;
};

export const SubcategoryListItems = ({
  title = 'Подкатегория',
  onPress,
  isDisabled = false,
  isLoading = false,
  className = '',
}: SubcategoryListItemsProps) => {
  return (
    <Button
      disabled={isDisabled}
      radius="none"
      fullWidth
      variant="light"
      size="lg"
      className={`px-4 ${className}`}
      onPress={onPress}
      endContent={<ArrowRight2 size="24" color="#9CA5AC" />}
    >
      <Skeleton className="w-full rounded-lg" isLoaded={!isLoading}>
        <p className="w-full text-left">{title}</p>
      </Skeleton>
    </Button>
  );
};

export type SubcategoryListProps = {
  items?: (SubcategoryListItemsProps | undefined)[];
  isDivided?: boolean;
};

export const SubcategoryList = ({
  items = [],
  isDivided = true,
}: SubcategoryListProps) => {
  return (
    <ul className="-mx-4 py-4">
      {items?.map((item, index) => {
        return (
          <li key={index}>
            <SubcategoryListItems {...item} />
            {isDivided && index + 1 !== items?.length && (
              <div className="px-4">
                <Divider />
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};
